<template>
  <div class="content-page">
    <div class="main-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
        <div class="main-contentBox">
          <!-- 主要内容区域 -->
          <div class="main-content-area">
            <div class="choose-buttons">
              <div class="choose-btn personal-btn" @click="selectCategory('1')">
                个人
              </div>
              <div
                class="choose-btn organization-btn"
                @click="selectCategory('2')"
              >
                法人/组织
              </div>
            </div>
          </div>
          <div class="btnLists">
          <div class="border-btn" style="marginLeft:20px" @click="goBack" >返回上一页</div>
        </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    selectCategory(applicantCategory) {
      // 保存申请类型到 localStorage
      localStorage.setItem("applicantCategory", applicantCategory);
      localStorage.setItem('applicantInfo', JSON.stringify({
        ...JSON.parse(localStorage.getItem('applicantInfo')),
        applicantCategory: applicantCategory
      }));
      // 跳转到 NewCase 页面
      if (localStorage.getItem('oprate') == 'apply') {
        this.$router.push({
          name: "NewCase",
        });
      } else {
        // 从 localStorage 的 applicantInfo 中获取数据
        const applicantInfo = localStorage.getItem('applicantInfo') 
          ? JSON.parse(localStorage.getItem('applicantInfo')) 
          : null
        
        // 从 store 中获取用户信息，如果没有则从 applicantInfo 中获取
        const phone = applicantInfo ? applicantInfo.phone : (this.$route.query.phone || '')
        const loginName = this.user.loginName || (applicantInfo ? applicantInfo.loginName : '') || this.$route.query.loginName || ''
        const identificationCard = this.user.identificationCard || (applicantInfo ? applicantInfo.identificationCard : '') || this.$route.query.identificationCard || ''
        const searchType = this.$route.query.searchType || ''
        
        this.$router.push({
          name: 'caselist',
          query: {
            name: localStorage.getItem('oprate'),
            phone: phone,
            searchType: searchType,
            loginName: loginName,
            applicantCategory: applicantCategory,
            identificationCard: identificationCard
          }
        });
      }
    },
    goBack () {
      if (localStorage.getItem('oprate') == 'apply') {
        this.$router.push('/howApply');
      } else {
        this.$router.push('/codeSearch');
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 1000px) {
    .main-contentBox{
      padding: 15px 20px 15px !important;
    }
  }
.main-contentBox{
  width: 100%;
   padding: 60px 135px 80px;
  .how-contentBox{
    overflow: auto;
    height: 314px;
    margin-top: 50px;
  }
  .textBox{
    height: 240px;
     ::v-deep.el-step{
      .el-step__main{
        .el-step__title{
        color: #333;
        }
      }
    }
  }
  .consult-text{
    margin-top: 20px;
    margin-bottom: 50px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FE3535;
    i{
      font-size: 14px;
    }
  }
}
.main-content-area {
  height: 480px;
  .choose-buttons {
    height: 100%;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    .choose-btn {
      height: 70px;
      width: 300px;
      border-radius: 10px;
      border: 1px solid #fff;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      background: #4472FC;
    }
  }
}
</style>
</style>
